<template>
    <el-cascader v-if="districts"
        size="small"
        v-model="selectedOptions"
        :options="districts"
        @change="activeChange"
        :props="props"
        clearable
        @clean="activeChange"
        style="width:100%"
    >
    </el-cascader>
</template>

<script>
    import CommonService from "~/services/common";

    export default {
        name: "DistrictCascader",
        data() {
            return {
                //定义变量
                districts: [],
                props: {
                    value: 'id', 
                    label: 'label', 
                    // expandTrigger: 'hover',
                    checkStrictly: true
                },
                selectedOptions: [],
            };
        },

        props: {
            provinceId: {
                type: Number,
                default: 0,
                required: false
            },

            cityId: {
                type: Number,
                default: 0,
                required: false
            },

            districtId: {
                type: Number,
                default: 0,
                required: false
            },
        },

        //vue.js 钩子函数，在实例创建完成后立即调用
        created() {
            this.selectedOptions = [];
            this.getAreaTree();
            // console.log('进入：', this.provinceId, this.cityId, this.districtId);
        },

        methods: {

            getAreaTree() {
                CommonService.getAreaTree().then(res => {
                    if (res.code == 0 && res.data) {
                        this.districts = res.data;
                        this.setSelectedOptions();
                        // //如果省市区需要默认选中，否则值没有更改
                        if (typeof (this.selectedOptions) != '') {
                            this.activeChange(this.selectedOptions);
                        }
                    }
                })
            },

            //设置SelectedOptions数组，用于级联选择器默认选中
            setSelectedOptions() {
                if (!this.provinceId) return;
                this.selectedOptions.push(String(this.provinceId || ''));
                if (!this.cityId) return;
                this.selectedOptions.push(String(this.cityId || ''));
                if (!this.districtId) return;
                this.selectedOptions.push(String(this.districtId || ''));
            },

            activeChange(value) {
                this.selectedOptions = value;
                value = Object.assign([],value);
                if (!value[0]) value[0] = 0;
                if (!value[1]) value[1] = 0;
                if (!value[2]) value[2] = 0;
                this.$emit("change", value);
            },
            
            //地区选择value重置
            reset() {
                this.selectedOptions = [];
            },
        }
    }

</script>


// WEBPACK FOOTER //
// src/widgets/DistrictCascader.vue